import { NgModule } from '@angular/core';
import { LFDropdownModule } from '../../../../shared/dropdown/dropdown.module';
import { RouterModule } from '@angular/router';
import { TabbedViewChangerComponent } from './tabbed-view-changer.component';
import { SharedModule } from '../../../../shared/shared.module';

@NgModule({
    imports: [
        SharedModule,
        RouterModule,
        LFDropdownModule.forRoot(),
    ],
    exports: [TabbedViewChangerComponent],
    declarations: [TabbedViewChangerComponent],
})
export class TabbedViewChangerModule
{
}
